import { jsPDF } from 'jspdf';
import { font } from './Montserrat-normal';
import { praktikLogoBase64 } from '@/pdf/praktik-logo-base64';
import { getCaseItemsGrouped, getFinalCasePrice } from '@/libs/getFinalPrice';
import { getPrototypeByID } from '@/libs/libraryGetters';
import { getImage } from '@/libs/getImage';
import { useStoreItemsFromApi } from '@/Store/storeItemsFromApi';
import {
    tableColumnsScheme, tableColumnsSchemeSpecial,
} from '@/pdf/tableOptions';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreMeta } from '@/Store/storeMeta';
import { getScreenShot, getScreenshotWithPosition } from '@/libs/screenshot';
import { montserratBold } from '@/pdf/Montserrat-bold';
import { getCaseDataByModel, getDrawerSeparatorPrototypeById } from '@/libs/libGetters';
import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';


let positionY = 10;
const fontSizeMini = 11;
const fontSizeNormal = 15;
const fontSizeTitle = 15;
let docWidth = 0;
let docHeight = 0;
let paddingLeft = 18;
let paddingTop = 15;
let paddingBottom = 15;
let pageCount = 1;
let caseScreenHeight = 1;
let caseScreenWidth = 1;
let cardHorizontalBetweenGap = 10;
let cardVerticalBetweenGap = 15;
const fontSizeFactor = 0.43;
let tableRowHeight = 0;
const blackColor = '#333333';
const grayColor = '#999999';

let allItems = [];
let doc: jsPDF;

export async function createPDF() {
    positionY = 10;
    doc = new jsPDF({
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts: true,
    });
    //Setup
    docWidth = doc.internal.pageSize.getWidth();
    docHeight = doc.internal.pageSize.getHeight();
    doc.addFileToVFS('Montserrat.ttf', font);
    doc.addFileToVFS('MontserratBold.ttf', montserratBold);
    doc.addFont('Montserrat.ttf', 'Montserrat', 'normal');
    doc.addFont('MontserratBold.ttf', 'MontserratBold', 'normal');
    doc.setFont('Montserrat');
    doc.setFontSize(fontSizeNormal);
    paddingLeft = docWidth * 0.02;
    paddingTop = docWidth * 0.016;
    paddingBottom = docHeight - docWidth * 0.016;
    doc.setDrawColor(grayColor);
    allItems = [];
    pageCount = 1;
    caseScreenHeight = docWidth * 0.48;
    caseScreenWidth = docWidth * 0.4;
    let currencySymbol = '₽';
    if (useStoreMeta().currency && useStoreMeta().currency.length > 0) currencySymbol = useStoreMeta().currency;
    let finalWeight = 0;
    let maxSize = 0;
    const storeItemsFromApi = useStoreItemsFromApi();
    const caseItemsStartPosX = docWidth * 0.07;
    cardHorizontalBetweenGap = docWidth * 0.06;
    tableRowHeight = docWidth * 0.037;
    const storeProjectStructure = useStoreProjectStructure();
    const casesForProject = storeProjectStructure.cases;
    const selectedCaseId = useStoreProjectStructure().selectedCaseId;
    const screenshots = [];
    const specialCases=[];
    for (const toolCase of casesForProject) {
        const caseDataFromProject = storeProjectStructure.getCaseById(toolCase.id);
        if(!storeProjectStructure.checkIsDefaultColorById(toolCase.id)){
            specialCases.push(toolCase.id);
        }
        if (caseDataFromProject?.image && !caseDataFromProject?.image.includes('dist/src/img')) {
            const screenshot = await convertWebPToDataUrl(caseDataFromProject.image);
            screenshots.push(screenshot);
        } else {
            const screenshotData = getScreenshotWithPosition(500,500);
            const screenshot = await convertWebPToDataUrl(screenshotData);
            screenshots.push(screenshot);
        }
    }

    const isDefaultColoring=specialCases.length===0;
    cardVerticalBetweenGap=isDefaultColoring?15:10;
    //Шапка
    const finalPrice = storeProjectStructure.getProjectTotalPrice;
    addHeader();
    setFontFamily('bold');
    doc.text(storeProjectStructure.projectName, paddingLeft, docWidth * 0.15);
    if(isDefaultColoring){
        doc.text('Общая стоимость:', docWidth * 0.53, docWidth * 0.135);
        doc.text(`${finalPrice}`,
            docWidth - paddingLeft - doc.getTextWidth(`${finalPrice}`), docWidth * 0.135);
    } else{
        doc.text('Индивидуальный расчёт цены', docWidth * 0.529, docWidth * 0.135);
        setFontFamily('regular');
        doc.setTextColor(grayColor);

    }
    setFontFamily('regular');
    doc.setTextColor(grayColor);
    doc.setFontSize(fontSizeMini);
    doc.text('Создан ' + getFormattedDate(), docWidth * 0.53, docWidth * 0.17);
    doc.text('Шкафов: ' + casesForProject.length, docWidth - paddingLeft - doc.getTextWidth('Шкафов: 5'), docWidth * 0.17);
    doc.setFontSize(fontSizeNormal);
    doc.setTextColor(blackColor);
    doc.line(paddingLeft, docWidth * 0.2, docWidth - paddingLeft, docWidth * 0.2);
    positionY = docWidth * 0.2;

    casesForProject.forEach((toolCase, index) => {
        const caseDataFromProject = storeProjectStructure.getCaseById(toolCase.id);
        const caseData: iStoreCaseConfiguration = useStoreProjectStructure().getCaseDataById(toolCase.id);
        const isSpecialCase=specialCases.includes(toolCase.id);
        let casePrototype;
        if (toolCase.id == selectedCaseId) {
            casePrototype = useStoreCaseConfiguration().getSelectedCaseData;
        } else{
            if (caseData.selectedCaseModel) {
                casePrototype=getCaseDataByModel(caseData.selectedCaseModel);
            } else {
                console.warn('В библиотеке шкафов не найден шкаф ', caseData.selectedCaseModel);
            }

        }
        if (!casePrototype || !caseDataFromProject) return console.warn('No data for case ' + toolCase.id);
        const caseItemData = {
            count: 1,
            prototype:casePrototype,
        };
        const isHardCase = casePrototype.key.toLowerCase().includes('hard');

        const caseItems = getCaseItemsGrouped(toolCase.id);
        if (!isHardCase) caseItems.unshift(caseItemData);
        const caseFullPrice = getFinalCasePrice(toolCase.id);
        const caseCount = caseDataFromProject.count;
        //Фото шкафа
        positionY += docWidth * 0.03;
        if (screenshots[index]){
            doc.addImage(screenshots[index],'PNG', caseItemsStartPosX, positionY, docWidth * 0.4, docWidth * 0.48);
        }
        //Данные о шкафе
        positionY += docWidth * 0.03;
        const caseDataPosX = docWidth * 0.535;
        //Название шкафа
        setFontFamily('bold');
        doc.setFontSize(fontSizeNormal);
        doc.setTextColor(blackColor);
        doc.text(storeProjectStructure.getCaseById(toolCase.id)?.name ?? '', caseDataPosX, positionY);
        positionY += docWidth * 0.06;
        const addCommonDataLine = (leftString: string, rightString: string) => {
            setFontFamily('regular');
            doc.text(leftString, caseDataPosX, positionY);
            setFontFamily('bold');
            doc.text(rightString, caseDataPosX + 50, positionY);
        };
        doc.setFontSize(fontSizeMini);
        if (!casePrototype?.xmlId) console.warn('No xmlId for case ', casePrototype);
        const itemFromApi = storeItemsFromApi.getApiItemByXmlId(casePrototype.xmlId);
        let caseCommonWeightString = 0;
        // console.log('PDF cards content',caseItems);
        caseItems.forEach(item => {
            //TODO высчитывание веса. Сделано в попыхах, надо сбор данных о предметах сделать заранее и вынести сюда, в удобный вид данных
            let prototype = item.prototype ? item.prototype : getPrototypeByID(item.prototypeId);
            if (!prototype) {
                prototype = getDrawerSeparatorPrototypeById(item.prototypeId);
            }
            const apiDataForGroup = storeItemsFromApi.getApiItemByXmlId(prototype.xmlId);
            // if (typeof apiDataForGroup === 'undefined') return;
            let itemWeight = +(apiDataForGroup?.weight.replace(',', '.') ?? 0);
            if (Number.isNaN(itemWeight)) itemWeight = 0;
            if (!apiDataForGroup) {
                console.error('No api data for ' + prototype.xmlId);
                itemWeight = 0;
            }
            if (apiDataForGroup && !apiDataForGroup?.price) {
                apiDataForGroup.price = '0';
                console.error('No price for ', prototype.name);
            }
            item.weight = itemWeight;
            caseCommonWeightString += itemWeight * item.count;
            finalWeight += itemWeight * item.count;

        });
        addCommonDataLine('Вес, кг.:', '' + floatNullReplace(caseCommonWeightString.toFixed(2)));
        positionY += 7;
        if (
            itemFromApi &&
            typeof itemFromApi.height !== 'undefined' && itemFromApi.height !== null &&
            typeof itemFromApi.width !== 'undefined' && itemFromApi.width !== null &&
            typeof itemFromApi.depth !== 'undefined' && itemFromApi.depth !== null
        ) {
            addCommonDataLine('Габариты, мм.:', `${itemFromApi.height} х ${itemFromApi.width} х ${itemFromApi.depth}`);
            positionY += 13;
        }
        if(!isSpecialCase){
            addCommonDataLine('Стоимость, ' + currencySymbol + ':', '' + caseFullPrice);
            positionY += 7;
        }
        addCommonDataLine('Количество, шт.: ', caseCount + '');
        positionY += 7;
        setFontFamily('bold');
        if(!isSpecialCase){
            doc.text('Итого, ' + currencySymbol + ':', caseDataPosX, positionY);
            doc.text('' + caseFullPrice * caseCount, caseDataPosX + 50, positionY);
            positionY += 7;
        }else{
            doc.text('Расчёт цены индивидуально', caseDataPosX, positionY);
            positionY += 7;
            setFontFamily('regular');
            doc.text('Нестандартное исполнение' , caseDataPosX, positionY);
            positionY += 7;
        }
        doc.line(caseDataPosX, positionY, docWidth - paddingLeft, positionY);
        positionY += 7;
        //Комплектующие
        doc.text('Состав комплектующих одного шкафа:', caseDataPosX, positionY);
        setFontFamily('regular');
        positionY += 7;
        let caseItemsPosX = caseDataPosX;
        let cardLinePosY = positionY;
        const cardWidth = docWidth * 0.164;
        const cardImageHeight = docWidth * 0.1;
        caseItems.forEach((item, index) => {
            doc.setFontSize(9);
            let prototype = item.prototype ? item.prototype : getPrototypeByID(item.prototypeId);
            if (!prototype) {
                prototype = getDrawerSeparatorPrototypeById(item.prototypeId);
            }
            if (!prototype) return console.warn('No prototype data for ', item.prototypeId);
            const apiDataForGroup = storeItemsFromApi.getApiItemByXmlId(prototype.xmlId);
            // if (typeof apiDataForGroup === 'undefined') return;
            if (maxSize < (+(apiDataForGroup?.height ?? 0))) maxSize = apiDataForGroup.height;
            if (maxSize < (+(apiDataForGroup?.width ?? 0))) maxSize = apiDataForGroup.width;
            if (maxSize < (+(apiDataForGroup?.depth ?? 0))) maxSize = apiDataForGroup.depth;
            //Изображение
            const itemImage = getImage(prototype.image);
            if (itemImage) doc.addImage(itemImage, caseItemsPosX, positionY, cardWidth, cardImageHeight);
            //Количество
            const countLine = item.count + ' шт.';
            const itemCountLinePosX = caseItemsPosX + cardWidth - doc.getTextWidth(countLine);
            const itemCountLinePosY = positionY + cardImageHeight - 5;
            doc.setFillColor('#f2f2f2').rect(itemCountLinePosX - 1, itemCountLinePosY - 3.5, 9, 5, 'F');
            doc.text(countLine, itemCountLinePosX, itemCountLinePosY);
            //Название
            positionY += cardImageHeight + 3;
            const nameStringArray = splitTitleToFitWidth(prototype.name, cardWidth, 3);
            nameStringArray.forEach((string, index) => {
                if (doc.getTextWidth(string) > cardWidth && index == nameStringArray.length - 1) {
                    string = cutStringToFitWidth(string, cardWidth);
                }
                doc.text(string, caseItemsPosX, positionY);
                positionY += 5;
            });
            positionY += 2;
            //Цена за штуку
            if(!isSpecialCase){
                setFontFamily('bold');
                const casePrice = apiDataForGroup?.price ?? 0;
                doc.text(casePrice + ' '+currencySymbol+'/шт.', caseItemsPosX, positionY);
            }
            setFontFamily('regular');
            addItemToAllItems({
                ...prototype,
                ...apiDataForGroup,
                count: item.count * caseDataFromProject.count,
            });
            //Перемещение
            if (caseItemsPosX + cardWidth * 2 > docWidth - paddingLeft) {
                if (positionY + 25 + cardVerticalBetweenGap + cardImageHeight > paddingBottom) {
                    nextPage();
                    cardLinePosY = docWidth * 0.13;
                } else cardLinePosY = positionY + 4 + cardVerticalBetweenGap;
                caseItemsPosX = caseItemsStartPosX;
            } else caseItemsPosX += cardWidth + cardHorizontalBetweenGap;
            positionY = cardLinePosY;
        });
        nextPage();
    });

    //Шапка таблицы
    const tableColumns=isDefaultColoring?tableColumnsScheme:tableColumnsSchemeSpecial;

    doc.setFontSize(fontSizeMini);
    setFontFamily('bold');
    let columnPositionX = paddingLeft;
    tableColumns.forEach((columnData) => {
        const rectWidth = (docWidth - paddingLeft * 2) * columnData.fraction;
        columnData.text = columnData.text.replace('₽', currencySymbol);
        doc.rect(columnPositionX, positionY, rectWidth, tableRowHeight);
        const textPositionX = columnPositionX + 2;
        const columnPositionY = positionY + doc.getFontSize() * fontSizeFactor;
        doc.text(columnData.text, textPositionX, columnPositionY);
        columnPositionX += rectWidth;
    });
    columnPositionX = paddingLeft;
    positionY += tableRowHeight;
    setFontFamily('regular');
    //Контент таблицы
    // console.log('PDF table content',allItems);
    allItems.forEach((item, index) => {
        if (positionY >= paddingBottom) {
            nextPage();
        }
        const itemFinalPrice = item.count * (item.price ?? 0);
        const isAllSizesPresent = item.height && item.width && item.depth;
        const itemSizesString = isAllSizesPresent ? `${item.height + ' х ' + item.width + ' х ' + item.depth}` : 'Недоступны';
        let textArray = [
            '' + (index + 1),
            '' + item.name ?? 'Название недоступно',
            itemSizesString,
            `${item.weight ?? 0}`,
            '' + (item.price ?? 0),
            '' + item.count,
            '' + itemFinalPrice ];
        if(!isDefaultColoring){
            textArray=[ textArray[0], textArray[1],textArray[2],textArray[3],textArray[5] ];
        }
        const textPositionY = positionY;
        const cellPadding=2;
        const nameTableTextArray = splitTitleToFitWidth(textArray[1], (docWidth - paddingLeft * 2) * tableColumns[1].fraction-cellPadding, 5);
        const currRowHeight = Math.max(tableRowHeight, nameTableTextArray.length * 6.5);
        tableColumns.forEach((columnData, columnIndex) => {
            const rectWidth = (docWidth - paddingLeft * 2) * columnData.fraction;
            const columnTextArray = splitTitleToFitWidth(textArray[columnIndex], rectWidth - cellPadding, 5);
            columnTextArray.forEach((textLine, index) => {
                const textPositionX = columnPositionX + cellPadding;
                doc.text(textLine, textPositionX, textPositionY + 5 * (index + 1));
            });
            // currRowHeight=currRowHeight*columnTextArray.length;
            doc.rect(columnPositionX, positionY, rectWidth, currRowHeight);
            columnPositionX += rectWidth;
        });
        columnPositionX = paddingLeft;
        positionY += currRowHeight;
    });

    //Итоги
    if (positionY >= docWidth * 1.06) {
        nextPage();
    }
    positionY = docWidth * 1.06;
    const summaryPosX = docWidth * 0.64;
    const storeMeta = useStoreMeta();
    const city = storeMeta.city;
    const addressEmail = storeMeta.addressEmail;
    const addressPhone = storeMeta.addressPhone;
    const addressSite = storeMeta.addressSite;
    const addressValue = storeMeta.addressValue;
    if(isDefaultColoring){
        setFontFamily('bold');
        doc.text('Итого:', summaryPosX, positionY);
        doc.text(finalPrice + ' ' + currencySymbol, docWidth - paddingLeft - doc.getTextWidth(finalPrice + ' ' + currencySymbol), positionY);
        positionY += 7;
    }

    setFontFamily('regular');
    doc.text('Общий вес', summaryPosX, positionY);
    const finalWeightString = floatNullReplace(finalWeight.toFixed(2));
    setFontFamily('bold');
    doc.text(finalWeightString + ' кг',
        docWidth - paddingLeft - doc.getTextWidth(finalWeightString + ' кг'), positionY);
    setFontFamily('regular');
    positionY += 7;
    doc.text('Максимальный габарит:', summaryPosX, positionY);
    setFontFamily('bold');
    doc.text(maxSize + ' мм', docWidth - paddingLeft - doc.getTextWidth(maxSize + ' мм.'), positionY);
    setFontFamily('regular');
    positionY += 7;
    //Контакты
    const contactsInfoPosX = 30;
    doc.line(paddingLeft, positionY, docWidth - paddingLeft, positionY);
    positionY += 7;
    doc.text('Адрес:', paddingLeft, positionY);
    doc.text(`${city}, ${addressValue}`, contactsInfoPosX, positionY);
    positionY += 7;
    doc.text('Телефон:', paddingLeft, positionY);
    doc.text(addressPhone, contactsInfoPosX, positionY);
    positionY += 7;
    doc.text('Email:', paddingLeft, positionY);
    doc.text(addressEmail, contactsInfoPosX, positionY);
    positionY += 7;
    doc.text('Сайт:', paddingLeft, positionY);
    doc.text(addressSite, contactsInfoPosX, positionY);
    positionY += 7;
    doc.line(paddingLeft, positionY, docWidth - paddingLeft, positionY);
    addNumerification();
    return doc;
}

function addHeader() {
    //Logo
    doc.addImage(praktikLogoBase64, paddingLeft, paddingTop, docWidth * 0.182, docWidth * 0.05);
    //Надпись
    const prevFontSize = doc.getFontSize();
    doc.setFontSize(fontSizeNormal);
    setFontFamily('bold');
    doc.setTextColor('#00458D');
    doc.text('СПЕЦИФИКАЦИЯ', docWidth * 0.73, docWidth * 0.05);
    doc.setTextColor('#333333');
    doc.line(paddingLeft, docWidth * 0.08, docWidth - paddingLeft, docWidth * 0.08);
    positionY = docWidth * 0.1;
    doc.setFontSize(prevFontSize);
    setFontFamily('regular');
}

function nextPage() {
    pageCount += 1;
    doc.addPage();
    addHeader();
}

function addItemToAllItems(itemGroup: any) {
    if (allItems.some(item => item.xmlId == itemGroup.xmlId)) {
        const prevItemGroup = allItems.find(item => item.xmlId == itemGroup.xmlId);
        prevItemGroup.count += itemGroup.count;
        return;
    }
    allItems.push(itemGroup);
}

function addNumerification() {
    positionY = docHeight - 8;
    doc.setFontSize(fontSizeMini);
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        const line = 'Страница ' + i + ' из ' + pageCount;
        const lineWidth = doc.getTextWidth('Страница ' + i + ' из ' + pageCount);
        doc.text(line, (docWidth / 2) - (lineWidth / 2), positionY);
    }
}

function setFontFamily(type: 'bold' | 'regular') {
    switch (type) {
        case 'bold':
            doc.setFont('MontserratBold');
            break;
        case 'regular':
            doc.setFont('Montserrat');
            break;
        default:
            return;
    }
}

// Функция для разделения текста на строки по заданной ширине
function splitTitleToFitWidth(title: string, columnWidth: number, linesCount: number) {
    const parts = title.split(' ');
    let currentLine = '';
    let resultParts = [];

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        const newLine = currentLine + (currentLine ? ' ' : '') + part;

        if (doc.getTextWidth(newLine) > columnWidth) {
            if (currentLine) {
                resultParts.push(currentLine);
                currentLine = part;
            } else {
                // Если одно слово превышает ширину столбца
                resultParts.push(part);
                currentLine = '';
            }
        } else {
            currentLine = newLine;
        }

        // Условие для остановки после двух строк
        if (resultParts.length === linesCount - 1 && doc.getTextWidth(currentLine) > columnWidth) {
            break;
        }
    }

    // Добавление последней строки, если она существует
    if (currentLine) {
        resultParts.push(currentLine);
    }

    // Если результат содержит более двух строк, объединяем вторую и последующие
    if (resultParts.length > linesCount) {
        resultParts[linesCount - 1] = resultParts.slice(linesCount - 1).join(' ');
        resultParts = resultParts.slice(0, linesCount);
    }

    return resultParts;
}

function cutStringToFitWidth(string: string, width: number) {
    const ellipsis = '...';
    let result = string;
    while (result.length > 0 && doc.getTextWidth(result + ellipsis) > width) {
        result = result.slice(0, -1);
    }

    return result + (result.length < string.length ? ellipsis : '');
}

function getFormattedDate() {
    const d = new Date();
    return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()} в ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export const loadResultPDF = function() {
    return new Promise(function(resolve, reject) {
        createPDF().then(doc => {
            doc.save('Практик Profi спецификация.pdf');
            positionY = 10;
            resolve();
        }).catch((err) => {
            reject(err);
        });
    });
};

async function convertWebPToDataUrl(webpImagePath: string, quality = 0.5) {
    const img = new Image();
    img.src = webpImagePath;
    const containerHeight = caseScreenHeight * 10;
    const containerWidth = caseScreenWidth * 10;
    return await new Promise((resolve, reject) => {
        img.onload = () => {
            const targetWidth = (img.width / img.height) * containerHeight;

            const canvas = document.createElement('canvas');
            canvas.width = containerWidth;
            canvas.height = containerHeight;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            const sourceX = 0;
            const sourceY = 0;
            const sourceWidth = img.width;
            const sourceHeight = img.height;

            // Центрируем по горизонтали
            const destX = (containerWidth - targetWidth) / 2;
            const destY = 0;
            const destWidth = targetWidth;
            const destHeight = containerHeight;

            ctx.drawImage(
                img,
                sourceX, sourceY, sourceWidth, sourceHeight,
                destX, destY, destWidth, destHeight,
            );

            const dataURL = canvas.toDataURL('image/jpeg', quality);
            resolve(dataURL);
        };

        img.onerror = (error) => {
            reject(new Error('Не удалось загрузить изображение: ' + error));
        };
    });
}

export async function getBase64PDF() {
    return new Promise(function(resolve, reject) {
        createPDF().then(doc => {
            const base64data = doc.output('datauristring');
            resolve(base64data);
        }).catch((err) => {
            reject(err);
        });
    });
}

export function floatNullReplace(num: string | number) {
    let str = num.toString();

    str = str.replace(/\.?0+$/, '');
    return Number(str);
}
